import React from 'react';
const delay = require('mn-utils/delay');
const loopMap = require('mn-utils/loopMap');
const Emitter = require('mn-utils/Emitter');
const {
  backLocation,
} = require('../router');
const {
  paramStore,
} = require('../stores');
const openWithOptionsProvider = require('../utils/openWithOptionsProvider');
const PopupInfo = require('../components/dumb/Popup/Info');
const V1PopupInfo = require('../components/dumb/Popup/v1Info');
const PopupError = require('../components/dumb/Popup/Error');

let _popupWindowLastId = 0;
const popupWindowCurrent$ = paramStore('window', 0);
const popupWindowItems$ = new Emitter();
export const popupWindowParams$ = Emitter.combine([
  popupWindowCurrent$,
  popupWindowItems$,
]);
export const popupWindow$ = popupWindowParams$.map(([current, items]) => {
  return current && items && items.length >= current;
});
export function openPopupWindow(init) {
  const index = parseInt(popupWindowCurrent$.getValue());
  const current = 1 + index;
  const renders = [...(popupWindowItems$.getValue() || [])];
  renders[index] = {
    id: ++_popupWindowLastId,
    index: current,
    init,
  };
  delay(() => {
    popupWindowItems$.emit(renders);
    popupWindowCurrent$.emit(current);
  }, 100);
}

loopMap(popupWindowCurrent$.getValue(), backLocation);


export function openPopupInfo(args) {
  openPopupWindow((setPopupState, popup) => {
    return (stateOfPopup) => {
      return (<PopupInfo
        args={args}
        onClose={popup.close}
      />);
    };
  });
}

export function openV1PopupInfo(args) {
  openPopupWindow((setPopupState, popup) => {
    return (stateOfPopup) => {
      return (<V1PopupInfo
        args={args}
        onClose={popup.close}
      />);
    };
  });
}

export function openPopupError(message) {
  openPopupWindow((setPopupState, popup) => {
    return (stateOfPopup) => {
      return (<PopupError
        message={message}
        onClose={popup.close}
      />);
    };
  });
}

export const popup$ = paramStore('popup');

export const openChangePassword$ = popup$.is('password');
export const terminalsOrderSuccess$ = popup$.is('terminals_order_success');
export const [
  approve$,
  approveOpen,
] = openWithOptionsProvider(popup$.is('approve'));
export const [
  adminTerminal$,
  adminTerminalOpen,
] = openWithOptionsProvider(paramStore('adminTerminal'), backLocation);


popup$.getValue() && backLocation();
